var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error-page flex-mid",class:("error-page-" + _vm.code)},[_c('Button',{staticClass:"btn-back",attrs:{"type":"primary"},on:{"click":function($event){return _vm.$router.back()}}},[_vm._v(_vm._s(_vm.$t('base.back')))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }